var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.9272mm",
    height: "10.3742mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 603.28 524.73",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2465000527504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M100.9 385.82l0 88.33 -12.17 -0.01 0 -75.34 -20.47 12.58 -5.35 -8.7 26.77 -16.86 11.23 0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M315.42 385.55c3.89,1.93 7.15,4.95 9.36,8.69 2.2,3.69 3.35,7.92 3.35,12.21 0,0.03 0,0.07 0,0.1 0,5.33 -1.24,10.61 -3.61,15.39 -3.06,5.8 -6.85,11.21 -11.24,16.06 -4.95,5.62 -12.58,13.38 -22.88,23.82l40.15 0.01 -1.34 10.17 -52.19 0 0 -9.64c11.78,-12.18 20.08,-21.14 25.03,-26.77 4.13,-4.49 7.69,-9.49 10.57,-14.87 2.11,-4.11 3.22,-8.68 3.22,-13.31 0,-0.03 0,-0.05 0,-0.08 0.02,-0.25 0.02,-0.51 0.02,-0.76 0,-3.75 -1.45,-7.36 -4.04,-10.07 -2.67,-2.51 -6.2,-3.9 -9.87,-3.9 -0.23,0 -0.46,0.01 -0.69,0.02 -0.09,0.01 -0.17,0.01 -0.25,0.01 -3.22,0 -6.4,0.78 -9.25,2.28 -3.26,1.98 -6.2,4.48 -8.7,7.36l-7.9 -6.29c3.2,-4.21 7.33,-7.65 12.04,-10.04 4.4,-2.2 9.27,-3.35 14.19,-3.35 0.17,0 0.36,0.01 0.53,0.01 0.26,-0.01 0.52,-0.01 0.78,-0.01 4.41,0 8.78,1.01 12.73,2.95l0 0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M92.73 524.73c-0.03,-0.02 -0.09,-0.02 -0.13,-0.02 -51.14,0 -92.61,-41.47 -92.61,-92.61 0,-51.14 41.47,-92.61 92.61,-92.61 51.14,0 92.61,41.47 92.61,92.61 0,0.04 0,0.1 0,0.14 -0.07,51.04 -41.44,92.4 -92.47,92.47l-0.01 0.02zm0 -173.98c-44.93,-0.02 -81.36,36.42 -81.36,81.35 0,44.93 36.44,81.37 81.37,81.37 44.88,0 81.3,-36.36 81.37,-81.24 -0.07,-44.89 -36.47,-81.29 -81.37,-81.36l-0.01 -0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M301.63 524.73c-51.13,-0.02 -92.6,-41.49 -92.6,-92.62 0,-51.14 41.47,-92.61 92.6,-92.61 51.13,0 92.6,41.47 92.6,92.61 0,0.04 0,0.1 0,0.14 -0.07,51.09 -41.52,92.47 -92.6,92.47 0,0 0,0 0,0l-0.01 0.02zm0 -173.98c-44.92,-0.02 -81.36,36.42 -81.36,81.35 0,44.93 36.44,81.37 81.36,81.37 44.93,0 81.36,-36.44 81.36,-81.37 -0.07,-44.87 -36.49,-81.23 -81.36,-81.23 0,0 0,0 0,0l-0.01 -0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M510.67 524.73c-51.14,-0.02 -92.61,-41.49 -92.61,-92.62 0,-51.14 41.47,-92.61 92.61,-92.61 51.14,0 92.61,41.47 92.61,92.61 0,0.04 0,0.1 0,0.14 -0.15,51.06 -41.55,92.41 -92.61,92.48l0 0.01zm0 -173.98c-0.05,-0.02 -0.1,-0.02 -0.14,-0.02 -44.93,0 -81.37,36.44 -81.37,81.37 0,44.93 36.44,81.37 81.37,81.37 44.93,0 81.37,-36.44 81.37,-81.37 -0.07,-44.82 -36.41,-81.16 -81.24,-81.23l0.01 -0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M523.11 388.76c7.51,3.47 12.32,11.01 12.32,19.29 0,0.04 0,0.07 0,0.11 0.01,0.26 0.02,0.52 0.02,0.77 0,4.63 -1.67,9.11 -4.7,12.61 -3.33,3.58 -7.68,6.05 -12.45,7.1 5.36,0.34 10.43,2.57 14.32,6.28 3.63,3.78 5.65,8.83 5.65,14.07 0,0.35 -0.01,0.71 -0.03,1.06 -0.05,4.71 -1.35,9.33 -3.75,13.38 -2.53,4.19 -6.2,7.58 -10.58,9.77 -4.76,2.29 -9.98,3.48 -15.27,3.48 -0.17,0 -0.36,-0.01 -0.53,-0.01 -0.2,0 -0.41,0.01 -0.61,0.01 -4.9,0 -9.75,-1.01 -14.24,-2.95 -4.55,-2.05 -8.58,-5.12 -11.78,-8.96l7.36 -6.69c2.48,2.74 5.49,4.97 8.83,6.56 3.03,1.41 6.33,2.14 9.67,2.14 0.12,0 0.25,-0.01 0.36,-0.01 0.45,0.04 0.9,0.06 1.35,0.06 4.47,0 8.77,-1.69 12.04,-4.73 3.1,-3.14 4.84,-7.36 4.84,-11.77 0,-0.27 -0.01,-0.55 -0.02,-0.81 0.06,-0.54 0.09,-1.09 0.09,-1.64 0,-4.05 -1.68,-7.92 -4.64,-10.67 -3.4,-2.4 -7.47,-3.69 -11.64,-3.69 -0.58,0 -1.17,0.03 -1.75,0.08l-6.69 0.01 1.47 -9.37 4.55 0c0.18,-0.01 0.36,0 0.54,0 3.98,0 7.82,-1.43 10.83,-4.03 2.92,-2.75 4.58,-6.59 4.58,-10.61 0,-0.3 -0.01,-0.6 -0.03,-0.9 0.01,-0.11 0.01,-0.23 0.01,-0.34 0,-3.6 -1.45,-7.05 -4.02,-9.56 -2.7,-2.35 -6.16,-3.64 -9.74,-3.64 -0.28,0 -0.56,0.01 -0.83,0.03 -0.07,-0.01 -0.13,-0.01 -0.19,-0.01 -3.2,0 -6.37,0.64 -9.32,1.87 -3.25,1.51 -6.25,3.55 -8.83,6.03l-6.29 -7.23c6.61,-6.4 15.43,-10.05 24.63,-10.17 0.3,-0.01 0.61,-0.02 0.92,-0.02 4.69,0 9.32,1.06 13.54,3.09l0 0.02z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 87.11,
    width: 11.24,
    height: 345.27
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 296.02,
    width: 11.24,
    height: 345.27
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 505.05,
    width: 11.24,
    height: 345.27
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc13);
export default __webpack_public_path__ + "static/media/ic_1_3.8756c07b02e2614e3cb3bcb1fffc706f.svg";
export { ForwardRef as ReactComponent };